import { PortalError } from './PortalError';

export class PrescriptionDownloadError extends PortalError {
  constructor() {
    super('PrescriptionDownloadError', 'Prescription was not correctly downloaded', 'prescript_download_error');
  }
}
